import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { useStyles } from './SubSideBar.styles';

export interface SubSideBarItem {
    id: string;
    label: string;
}

export interface SubSideBarProps {
    items: readonly SubSideBarItem[];
    /** The currently active section id (driven by scroll-spy). */
    selectedId: string | null;
    /** Called when the user clicks a sidebar item. */
    onItemClick: (id: string) => void;
    ariaLabel: string;
    automationId?: string;
}

/**
 * Inline secondary navigation rendered beside a detail-page's content area.
 * Active state is externally controlled via `selectedId` (typically from a
 * scroll-spy hook) and clicks are forwarded via `onItemClick`.
 */
export const SubSideBar = ({
    items,
    selectedId,
    onItemClick,
    ariaLabel,
    automationId = 'sub-side-bar',
}: SubSideBarProps) => {
    const { classes, cx } = useStyles();

    return (
        <Box className={classes.root} automation-id={automationId}>
            <nav className={classes.nav} aria-label={ariaLabel}>
                <List disablePadding>
                    {items.map((item) => {
                        const selected = item.id === selectedId;
                        return (
                            <ListItemButton
                                key={item.id}
                                selected={selected}
                                onClick={() => onItemClick(item.id)}
                                className={cx(classes.item, selected && classes.itemSelected)}
                                automation-id={`${automationId}-${item.id}`}
                            >
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </nav>
        </Box>
    );
};
